module.exports = __webpack_public_path__ + "img/2_36.ff5a37d5.png";